export default function ProgressLines({ steps = 1, currentStep }) {
  return (
    <div className=" absolute top-12 flex flex-row gap-4 justify-center">
      <div className={`h-1 w-10 rounded-lg bg-green-500`} />

      {[...Array(steps - 1).keys()].map((_, index) => (
        <div
          key={index}
          className={`h-1 w-10 rounded-lg ${
            currentStep -1 > index ? "bg-green-500" : "bg-gray-400"
          }`}
        />
      ))}
    </div>
  );
}
